<template>
  <el-dialog :title="$t('accountBond.addBond')" :visible.sync="dialogVisible" width="50%" @close="resetForm">
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item :label="$t('accountBond.shopType')" prop="objId">
        <el-select v-model="form.objId" :placeholder="$t('accountBond.selectShopType')" style="width: 100%"
          @change="setAddBondName">
          <el-option v-for="(item,index) in shopTypes" :key="index" :label="item.typeName" :value="item.shopTypeId" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('accountBond.bondName')" prop="bondName">
        <el-input v-model="form.bondName" disabled />
      </el-form-item>
      <el-form-item :label="$t('accountBond.amount')" prop="amount">
        <el-input v-model="form.amount" :placeholder="$t('accountBond.inputAmount')" />
      </el-form-item>
      <el-form-item :label="$t('accountBond.bondMonth')">
        <el-input v-model="form.bondMonth" :placeholder="$t('accountBond.inputBondMonth')" />
      </el-form-item>
      <el-form-item :label="$t('accountBond.remark')">
        <el-input v-model="form.remark" type="textarea" :placeholder="$t('accountBond.inputRemark')" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveAccountBondInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveAccountBond,queryShopType } from '@/api/admin/accountBondApi'

export default {
  name: 'AddAccountBond',
  data() {
    return {
      dialogVisible: false,
      shopTypes:[],
      form: {
        bondId: '',
        bondName: '',
        amount: '0',
        bondMonth: '',
        objId: '',
        bondType: '6006',
        remark: ''
      },
      rules: {
        objId: [
          { required: true, message: this.$t('accountBond.selectShopTypeRequired'), trigger: 'change' }
        ],
        bondName: [
          { required: true, message: this.$t('accountBond.bondNameRequired'), trigger: 'blur' },
          { min: 1, max: 20, message: this.$t('accountBond.bondNameLength'), trigger: 'blur' }
        ],
        amount: [
          { required: true, message: this.$t('accountBond.amountRequired'), trigger: 'blur' },
          { min: 1, max: 10, message: this.$t('accountBond.amountFormat'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._loadShopTypes()
    },
   async _loadShopTypes() {
      const res = await queryShopType({ page: 1, row: 100 })
      this.shopTypes = res.data
    },
    setAddBondName(objId) {
      const selectedType = this.shopTypes.find(item => item.shopTypeId === objId)
      if (selectedType) {
        this.form.bondName = selectedType.typeName
      }
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.form = {
        bondId: '',
        bondName: '',
        amount: '0',
        bondMonth: '',
        objId: '',
        bondType: '6006',
        remark: ''
      }
    },
    async saveAccountBondInfo() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveAccountBond(this.form)
            this.$message.success(this.$t('accountBond.addSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
}
</script>